@use 'kci-design-lib/styles/variables.scss' as *;
.custom-checkbox {
  display: flex;
  align-items: center;
  font-size: 14px;
  label {
    cursor: pointer;
    display: inline-block;
    position: relative;
  }
  &.checkbox-medium {
    .checkbox {
      width: 24px;
      height: 24px;
    }
    &.checkbox-color {
      .checkbox-label {
        font-size: 16px;
        line-height: 24px;
        letter-spacing: 0px;
        padding-left: 12px;
        color: var(--checkbox-radio-text);
      }
      &.default {
        &:hover {
          .checkbox {
            &::before {
              content: '';
              background: url('../../../assets/cb-hover-24.svg') left center
                no-repeat;
              width: 24px;
              height: 24px;
            }
          }
        }
        .checkbox {
          &::before {
            content: '';
            background: url('../../../assets/cb-default-24.svg') left center
              no-repeat;
            width: 24px;
            height: 24px;
          }
          &[data-p-highlight='true'] {
            &::before {
              content: '';
              background: url('../../../assets/cb-selected-24.svg') left center
                no-repeat;
              width: 24px;
              height: 24px;
            }
          }
        }
      }
      &.hover {
        .checkbox {
          &::before {
            content: '';
            background: url('../../../assets/cb-hover-24.svg') left center
              no-repeat;
            width: 24px;
            height: 24px;
          }
          &:not([data-p-highlight='true']) {
            &::before {
              content: '';
              background: url('../../../assets/cb-hover-24.svg') left center
                no-repeat;
              width: 24px;
              height: 24px;
            }
          }
          &[data-p-highlight='true'] {
            &::before {
              content: '';
              background: url('../../../assets/cb-selected-24.svg') left center
                no-repeat;
              width: 24px;
              height: 24px;
            }
          }
        }
      }
      &.selected {
        .checkbox {
          &::before {
            content: '';
            background: url('../../../assets/cb-selected-24.svg') left center
              no-repeat;
            width: 24px;
            height: 24px;
          }
        }
      }
      &.partial {
        .checkbox {
          &::before {
            content: '';
            background: url('../../../assets/cb-partial-24.svg') left center
              no-repeat;
            width: 24px;
            height: 24px;
          }
        }
      }
    }
    &.checkbox-default {
      .checkbox-label {
        font-size: 16px;
        line-height: 24px;
        letter-spacing: 0px;
        padding-left: 12px;
        color: $pbl-text-dsbl;
      }
      &.text-disabled {
        &.default {
          .checkbox {
            &::before {
              content: '';
              background: url('../../../assets/cb-default-dis-24.svg') left
                center no-repeat;
              width: 24px;
              height: 24px;
            }
          }
        }
        &.hover {
          .checkbox {
            &::before {
              content: '';
              background: url('../../../assets/cb-hover-dis-24.svg') left
                center no-repeat;
              width: 24px;
              height: 24px;
            }
          }
        }
        &.selected {
          .checkbox {
            &::before {
              content: '';
              background: url('../../../assets/cb-selected-dis-24.svg') left
                center no-repeat;
              width: 24px;
              height: 24px;
            }
          }
        }
        &.partial {
          .checkbox {
            &::before {
              content: '';
              background: url('../../../assets/cb-partial-dis-24.svg') left
                center no-repeat;
              width: 24px;
              height: 24px;
            }
          }
        }
      }
    }
  }
  &.checkbox-small {
    .checkbox {
      width: 20px;
      height: 20px;
    }
    &.checkbox-color {
      .checkbox {
        &[data-p-highlight='true'] {
          &::before {
            content: '';
            background: url('../../../assets/cb-selected-20.svg') left center
              no-repeat;
            width: 20px;
            height: 20px;
          }
        }
      }
      .checkbox-label {
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 0.2px;
        padding-left: 8px;
        color: var(--checkbox-radio-text);
      }
      &.default {
        &:hover {
          .checkbox {
            &::before {
              content: '';
              background: url('../../../assets/cb-hover-20.svg') left center
                no-repeat;
              width: 20px;
              height: 20px;
            }
          }
        }
        .checkbox {
          &::before {
            content: '';
            background: url('../../../assets/cb-default-20.svg') left center
              no-repeat;
            width: 20px;
            height: 20px;
          }
          &[data-p-highlight='true'] {
            &::before {
              content: '';
              background: url('../../../assets/cb-selected-20.svg') left center
                no-repeat;
              width: 20px;
              height: 20px;
            }
          }
        }
      }
      &.hover {
        .checkbox {
          &::before {
            content: '';
            background: url('../../../assets/cb-hover-20.svg') left center
              no-repeat;
            width: 20px;
            height: 20px;
          }
          &[data-p-highlight='true'] {
            &::before {
              content: '';
              background: url('../../../assets/cb-selected-20.svg') left center
                no-repeat;
              width: 20px;
              height: 20px;
            }
          }
        }
      }
      &.selected {
        .checkbox {
          &::before {
            content: '';
            background: url('../../../assets/cb-selected-20.svg') left center
              no-repeat;
            width: 20px;
            height: 20px;
          }
        }
      }
      &.partial {
        .checkbox {
          &::before {
            content: '';
            background: url('../../../assets/cb-partial-20.svg') left center
              no-repeat;
            width: 20px;
            height: 20px;
          }
        }
      }
    }
    &.checkbox-default {
      .checkbox-label {
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 0.2px;
        padding-left: 8px;
        color: $pbl-text-dsbl;
      }
      &.text-disabled {
        &.default {
          .checkbox {
            &::before {
              content: '';
              background: url('../../../assets/cb-default-dis-20.svg') left
                center no-repeat;
              width: 20px;
              height: 20px;
            }
          }
        }
        &.hover {
          .checkbox {
            &::before {
              content: '';
              background: url('../../../assets/cb-hover-dis-20.svg') left
                center no-repeat;
              width: 20px;
              height: 20px;
            }
          }
        }
        &.selected {
          .checkbox {
            &::before {
              content: '';
              background: url('../../../assets/cb-selected-dis-20.svg') left
                center no-repeat;
              width: 20px;
              height: 20px;
            }
          }
        }
        &.partial {
          .checkbox {
            &::before {
              content: '';
              background: url('../../../assets/cb-partial-dis-20.svg') left
                center no-repeat;
              width: 20px;
              height: 20px;
            }
          }
        }
      }
    }
  }
  .checkbox {
    opacity: 1;
    input {
      border: 0px;
      & + div {
        display: none; 
      }
    }
  }
}
